import LinkedAccountServiceCard from './LinkedAccountServiceCard';
import useFetchIam from '../../api/useFetchIam';
import { SERVICES, filterServicesByOrganization } from '../constants/services';

type Props = {
  onServiceSelect: (service: {
    name: string;
    imageUrl: string;
    type: 'multi' | 'auth';
    sourceType?: string;
  }) => void;
};

export default function LinkedAccountSelectService({ onServiceSelect }: Props) {
  const { data: iam } = useFetchIam();
  const organizationId = iam?.current_organization?.id;

  const filteredServices = filterServicesByOrganization(SERVICES, organizationId);

  const handleServiceSelect = (service: {
    name: string;
    imageUrl: string;
    type: 'multi' | 'auth';
    sourceType?: string;
  }) => {
    onServiceSelect(service);
  };

  return (
    <div className="m-[0_auto] grid w-[850px] grid-cols-3 gap-lg">
      {filteredServices.map((s, key) => {
        return (
          <LinkedAccountServiceCard
            key={key}
            imageUrl={s.imageUrl}
            name={s.name}
            onClick={() =>
              handleServiceSelect({
                name: s.name,
                imageUrl: s.imageUrl,
                type: s.type as 'multi' | 'auth',
                sourceType: s.sourceType,
              })
            }
          />
        );
      })}
    </div>
  );
}
